export const getImagePathsOfThumbs = {
  getLargeThumbPath: (fileName: string) => {
    return fileName
      .replace(/(.*)\//, '$1/large_thumb_webp_')
      .replace(/.jpg|.jpeg|.gif|.png|.bmp|.jfif|.tiff|.tif|.svg|.ico|.heic|.avif/gi, '.webp');
  },

  getMediumThumbPath: (fileName: string) => {
    return fileName
      .replace(/(.*)\//, '$1/medium_thumb_webp_')
      .replace(/.jpg|.jpeg|.gif|.png|.bmp|.jfif|.tiff|.tif|.svg|.ico|.heic|.avif/gi, '.webp');
  },
  getIconPath: (fileName: string) => {
    return fileName.replace(/(.*)\//, '$1/icon_');
  },
};
